import React from 'react'
import {EditGuesser} from '@api-platform/admin'
import {TextInput, NumberInput, ReferenceInput, AutocompleteInput, TextField, ReferenceField
} from 'react-admin';
import {useTranslation} from "react-i18next";


function Edit(props) {
    const {t} = useTranslation()

    return (
        <EditGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <ReferenceInput
                source="company"
                reference="dictionary/companies"
                label={t('brief.company')}
            >
                <AutocompleteInput optionText="name"/>
            </ReferenceInput>
            <NumberInput source="mpmId" label={'mpmId'}/>
        </EditGuesser>
    )
}

export default Edit
